import React, { useState } from "react";

import DashboardBarChart from "../../../../CommonComponents/Dashboard/DashboardBarChart/DashboardBarChart";

import "./stylesPurchases.css";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import DashboardLineChart from "../../../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";
import { Line } from "react-chartjs-2";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import { getAdminNow } from "../../../../../utils/dateService";

function Purchases({ isApiRunning }) {
  const headers = [
    {
      title: AppStrings.PURCHASES,
      amount: 120000,
      percentage: 10,
    },
    {
      title: AppStrings.PLAYERS_RECEIVED,
      amount: 100000,
      percentage: 15,
    },
    {
      title: AppStrings.PLAYERS_USED_BETS,
      amount: 180000,
      percentage: -10,
    },
  ];

  const [selectedHeader, setSelectedHeader] = useState(headers[0].title);
  const todayRange = [getAdminNow(), getAdminNow()];
  const [dates, setDates] = useState(todayRange);

  const keyFeatures = {
    labels: [
      "1st Sept",
      "2nd Sept",
      "3rd Sept",
      "4th Sept",
      "5th Sept",
      "6th Sept",
      "7th Sept",
      "8th Sept",
      "9th Sept",
      "10th Sept",
      "11th Sept",
      "12th Sept",
      "13th Sept",
      "14th Sept",
      "15th Sept",
      "16th Sept",
      "17th Sept",
      "18th Sept",
      "19th Sept",
      "20th Sept",
      "21st Sept",
      "22nd Sept",
      "23rd Sept",
      "24th Sept",
      "25th Sept",
      "26th Sept",
      "27th Sept",
      "28th Sept",
      "29th Sept",
      "30th Sept",
    ],
    datasets: [
      {
        label: AppStrings.PURCHASE_MATCH,
        data: [
          60, 30, 45, 15, 30, 20, 10, 25, 50, 15, 30, 45, 20, 35, 25, 40, 60,
          30, 45, 15, 30, 20, 10, 25, 50, 15, 30, 45, 20, 35,
        ],
        backgroundColor: ["#1ABC9C"],
        borderColor: ["#1ABC9C"],
        borderWidth: 1,
        pointRadius: 0,
        value: 128000,
      },
    ],
  };

  return (
    <div className="promotions-management-purchases-container">
      {isApiRunning ? (
        <RebetLoader height={"150px"} width={"150px"} />
      ) : (
        <>
          <div className="promotions-management-purchases-content">
            <div className="promotions-management-purchases-chart">
              <DashboardLineChart
                headers={headers}
                data={keyFeatures}
                isApiRunning={isApiRunning}
                rightInfo={false}
                setSelected={setSelectedHeader}
                showPresets={true}
                setDates={() => {}}
                dates={dates}
                getData={() => {}}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Purchases;
